if (!customElements.get('sc-recently-viewed')) {
  class ScRecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.fetchAttempts = 0;
      this.init();
    }

    async init() {
      try {
        const searchQuery = this.getSearchQuery();
        
        // If no items to show, hide the section
        if (!searchQuery) {
          this.innerHTML = '';
          return;
        }

        const response = await fetch(`${this.dataset.url}&q=${searchQuery}`);
        if (!response.ok) throw new Error(response.status);

        const div = document.createElement('div');
        div.innerHTML = await response.text();

        const fetchedSection = div.querySelector('sc-recently-viewed');
        if (!fetchedSection) {
          this.innerHTML = '';
          return;
        }

        // Render results in the order they were viewed
        const ul = fetchedSection.querySelector('ul');
        if (ul) {
          this.getItems().forEach((item) => {
            const card = fetchedSection.querySelector(`product-card[data-product-id="${item}"]`);
            const li = card?.closest('li');
            if (li) ul.appendChild(li);
          });
        }

        this.innerHTML = fetchedSection.innerHTML;
      } catch (error) {
        this.fetchAttempts += 1;

        if (this.fetchAttempts === 3) {
          console.log(error);
          this.innerHTML = '';
        } else {
          this.init();
        }
      }
    }

    getSearchQuery() {
      return this.getItems().map((item) => `id:${item}`).slice(0, this.dataset.limit).join(' OR ');
    }

    getItems() {
      const items = JSON.parse(localStorage.getItem('cc-recently-viewed') || '[]');

      if (this.dataset.exclude && items.includes(Number(this.dataset.exclude))) {
        items.splice(items.indexOf(Number(this.dataset.exclude)), 1);
      }

      return items;
    }
  }

  customElements.define('sc-recently-viewed', ScRecentlyViewed);
}